import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuPortal,
  DropdownMenuSubTrigger,
} from "../ui/dropdown-menu";
import ManualIcon from "../ui/icons/ManualIcon";

import { Text } from "../ui/text";

import { useTranslation } from "react-i18next";
import { overlay } from "overlay-kit";
import QuickStartDialog from "../dialog/quick-start-dialog";

const ManualPopup = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleManualLanguageClick = (language: "en" | "kr") => {
    let pdfUrl;
    if (language === "en") {
      pdfUrl = "/CellKey_SpAC9DataFoundry_UM_EN.pdf";
    } else {
      pdfUrl = "/CellKey_SpAC9DataFoundry_UM_KR.pdf";
    }
    const link = document.createElement("a");
    link.download = pdfUrl.split("/").pop() || "manual.pdf"; // 파일명 지정(선택)
    link.href = pdfUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleTutorialLanguageClick = (language: "en" | "kr" | "jp") => {
    let youtubeUrl;
    if (language === "en") {
      youtubeUrl = "https://youtu.be/Zi-pPz5Etow ";
    } else if (language === "jp") {
      youtubeUrl = "https://youtu.be/qAH30MUUWyE";
    } else {
      youtubeUrl = "https://youtu.be/7g8vxn4DoMc";
    }
    window.open(youtubeUrl, "_blank", "noopener,noreferrer");
  };

  const handleQuickStart = () => {
    overlay.open(({ isOpen, close }) => (
      <QuickStartDialog isOpen={isOpen} onClose={() => close()} />
    ));
  };

  return (
    <>
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger>
          <div
            className={`rounded-[4px] h-[40px] w-[40px] flex items-center justify-center ${
              !isOpen ? "" : "bg-grey-95 "
            }`}
          >
            <ManualIcon color={!isOpen ? "#4D4D4D" : "#1DB3A4"} />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          className="p-1 w-[140px] flex flex-col gap-[2px]"
          sideOffset={20}
        >
          {/* Manual 드롭다운 서브메뉴 */}
          <DropdownMenuSub>
            <DropdownMenuSubTrigger className="p-0 text-grey-20 hover:text-primary-30 group">
              <div className="w-10 h-10 flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z"
                    className="fill-[#808080] group-hover:fill-[#0AC4B2] transition-colors"
                  />
                </svg>
              </div>
              <Text variant={"label-lg"} className="text-inherit">
                {t("layout.manual")}
              </Text>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent sideOffset={8} alignOffset={-5}>
                <DropdownMenuItem
                  className="p-0 text-grey-20 hover:!text-primary-30"
                  onClick={() => handleManualLanguageClick("en")}
                >
                  <div className="pl-5 pr-1.5 h-10 flex items-center">
                    <Text variant={"label-lg"} className="text-inherit">
                      English
                    </Text>
                  </div>
                </DropdownMenuItem>
                <DropdownMenuItem
                  className="p-0 text-grey-20 hover:!text-primary-30"
                  onClick={() => handleManualLanguageClick("kr")}
                >
                  <div className="pl-5 pr-1.5 h-10 flex items-center">
                    <Text variant={"label-lg"} className="text-inherit">
                      한국어
                    </Text>
                  </div>
                </DropdownMenuItem>
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>

          {/* Tutorial 드롭다운 서브메뉴 */}
          <DropdownMenuSub>
            <DropdownMenuSubTrigger className="p-0 text-grey-20 hover:text-primary-30 group">
              <div className="w-10 h-10 flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    d="M17.4309 3.21619H4.56912C2.04566 3.21619 0 5.26185 0 7.7853V14.2148C0 16.7383 2.04566 18.7839 4.56912 18.7839H17.4309C19.9543 18.7839 22 16.7383 22 14.2148V7.7853C22 5.26185 19.9543 3.21619 17.4309 3.21619ZM14.3408 11.3129L8.32495 14.1821C8.16465 14.2585 7.97949 14.1417 7.97949 13.9641V8.04635C7.97949 7.86624 8.16952 7.74951 8.33016 7.83093L14.346 10.8795C14.5249 10.9701 14.5218 11.2266 14.3408 11.3129Z"
                    className="fill-[#808080] group-hover:fill-[#0AC4B2] transition-colors"
                  />
                </svg>
              </div>
              <div className="flex gap-2 items-center">
                <Text variant={"label-lg"} className="text-inherit">
                  {t("layout.tutorial")}
                </Text>
              </div>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent sideOffset={8} alignOffset={-47}>
                <DropdownMenuItem
                  onClick={() => handleTutorialLanguageClick("en")}
                  className="p-0 text-grey-20 hover:!text-primary-30 group"
                >
                  <div className="flex justify-between w-full items-center pl-4 pr-1.5 h-10">
                    <Text variant={"label-lg"} className="text-inherit">
                      English
                    </Text>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H10V4.16667H4.16667V15.8333H15.8333V10H17.5V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM8.08333 13.0833L6.91667 11.9167L14.6667 4.16667H11.6667V2.5H17.5V8.33333H15.8333V5.33333L8.08333 13.0833Z"
                        className="fill-[#808080] group-hover:fill-[#0AC4B2] transition-colors"
                      />
                    </svg>
                  </div>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => handleTutorialLanguageClick("kr")}
                  className="p-0 text-grey-20 hover:!text-primary-30 group"
                >
                  <div className="flex justify-between w-full items-center pl-4 pr-1.5 h-10">
                    <Text variant={"label-lg"} className="text-inherit">
                      한국어
                    </Text>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H10V4.16667H4.16667V15.8333H15.8333V10H17.5V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM8.08333 13.0833L6.91667 11.9167L14.6667 4.16667H11.6667V2.5H17.5V8.33333H15.8333V5.33333L8.08333 13.0833Z"
                        className="fill-[#808080] group-hover:fill-[#0AC4B2] transition-colors"
                      />
                    </svg>
                  </div>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => handleTutorialLanguageClick("jp")}
                  className="p-0 text-grey-20 hover:!text-primary-30 group"
                >
                  <div className="flex justify-between w-full items-center pl-4 pr-1.5 h-10">
                    <Text variant={"label-lg"} className="text-inherit">
                      日本語
                    </Text>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H10V4.16667H4.16667V15.8333H15.8333V10H17.5V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM8.08333 13.0833L6.91667 11.9167L14.6667 4.16667H11.6667V2.5H17.5V8.33333H15.8333V5.33333L8.08333 13.0833Z"
                        className="fill-[#808080] group-hover:fill-[#0AC4B2] transition-colors"
                      />
                    </svg>
                  </div>
                </DropdownMenuItem>
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>
          <DropdownMenuItem
            onClick={handleQuickStart}
            className="p-0 text-grey-20 hover:!text-primary-30 group"
          >
            <div className="flex w-full items-center">
              <div className="flex items-center justify-center w-10 h-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M10.55 18.2L15.725 12H11.725L12.45 6.325L7.825 13H11.3L10.55 18.2ZM8 22L9 15H4L13 2H15L14 10H20L10 22H8Z"
                    className="fill-[#808080] group-hover:fill-[#0AC4B2] transition-colors"
                  />
                </svg>
              </div>
              <Text variant={"label-lg"} className="text-inherit">
                Quick Start
              </Text>
            </div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default ManualPopup;
